import './icon.scss';
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '..';
const Icon = _ref => {
  let {
    name = '',
    className = '',
    onClick
  } = _ref;
  const {
    theme
  } = useTheme();
  const formattedName = useMemo(() => {
    if (name) {
      return className.includes('flag') || className.includes('country') ? name : `icon-${name.replace(/^icon-/, '')}`;
    }
    return '';
  }, [name]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-icon icon', className, theme, formattedName),
    onClick: onClick || undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }));
};
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default /*#__PURE__*/memo(Icon);